import { useSelector } from 'react-redux';
import { getTotalPrice } from '../ducks';

export const useGetTotalPrice = () => ({
  totalPrice: useSelector(getTotalPrice),
});
